import React, { useState, useEffect } from "react";
import { FaQuestionCircle } from "react-icons/fa";
import "../styles/CustomOrderHistory.css";
import MyPageSidebar from "./MyPageSidebar";
import { useNavigate } from "react-router-dom";
import MyPageEmpty from "./MyPageEmpty";

const CustomOrderHistory = () => {
    const navigate = useNavigate();
    const [showTooltip, setShowTooltip] = useState(false);
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // ✅ 서버에서 신청 내역 가져오기
    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await fetch("/api/application-list"); // 백엔드 엔드포인트 호출
                if (response.ok) {
                    const data = await response.json();

                    // API에서 받은 데이터를 orders 상태에 저장
                    if (data.submitApplications !== "noData") {
                        setOrders(data.submitApplications);
                    }
                } else {
                    console.error("신청 내역 불러오기 실패");
                }
            } catch (error) {
                console.error("서버 요청 중 오류 발생:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchOrders();
    }, []);

    const statusChange = {
        "WAITING": "접수 대기",
        "ACCEPTED": "접수 완료",
        "IN_PROGRESS": "제작 진행중",
        "PRODUCTION_COMPLETED": "제작 완료",
        "DELIVERY_COMPLETED": "상품 전달 완료",
        "REJECTED": "거절",
        "CANCEL" : "신청 취소"
    }

    // ✅ 상태별 버튼 스타일 매핑
    const statusStyles = {
        "접수 대기": "border-gray-300 text-gray-500",
        "접수 완료": "border-black text-black",
        "제작 진행중": "border-blue-500 text-blue-500",
        "제작 완료" : "border-gray-500 text-gray-500",
        "상품 전달 완료": "border-gray-300 text-gray-500",
        "거절": "border-red-500 text-red-500",
        "신청 취소": "border-orange-500 text-orange-500",
    };

    const handleOrderClick = (order) => {
        const applicationArticleId = order.applicationArticleId;
        navigate(`/mypage/custom-order/${applicationArticleId}`);
    }

    if (isLoading) return <p>로딩중...</p>;

    // ✅ 신청 내역이 없을 때
    if (orders.length === 0) {
        return (
            <div className="mypage-container">
                {/* ✅ 사이드바 */}
                <MyPageSidebar />

                {/* ✅ 본문 컨텐츠 */}
                <div className="order-content">
                    <h2 className="text-xl font-bold mb-4">맞춤상품 신청내역</h2>

                    {/* 신청내역 설명 */}
                    <div className="relative inline-block request-description">
                        <button
                            onClick={() => setShowTooltip(!showTooltip)}
                            className="text-blue-500 hover:underline flex items-center"
                        >
                            <FaQuestionCircle className="mr-1" />
                        </button>
                        {showTooltip && (
                            <div className="absolute z-10 w-72 p-3 bg-white border rounded-lg shadow-lg text-sm text-gray-700">
                                <p><strong>7단계의 현황으로 알려드립니다.</strong></p>
                                <p><span className="font-semibold text-gray-400">접수 대기</span> - 신청서 제출완료, 상담 진행 단계</p>
                                <p><span className="font-semibold text-black">접수 완료</span> - 상담완료, 제작 진행 전 단계</p>
                                <p><span className="font-semibold text-blue-500">제작 진행중</span> - 제작 진행중, 제작 완료 전 단계</p>
                                <p><span className="font-semibold text-gray-500">상품 제작 완료</span> - 제작 완료, 제작물 전달 전</p>
                                <p><span className="font-semibold text-gray-500">상품 전달 완료</span> - 제작 완료, 제작물 전달 전</p>
                                <p><span className="font-semibold text-red-500">거절</span> - 신청서 거절, 상담 진행 단계</p>
                                <p><span className="font-semibold text-orange-500">신청 취소</span> - 신청서 제출 후 취소</p>
                            </div>
                        )}
                    </div>

                    {/* 신청내역 리스트 */}
                    <MyPageEmpty />
                </div>
            </div>
        );
    }

    return (
        <div className="mypage-container">
            {/* ✅ 사이드바 */}
            <MyPageSidebar />

            {/* ✅ 본문 컨텐츠 */}
            <div className="order-content">
                <h2 className="text-xl font-bold mb-4">맞춤상품 신청내역</h2>

                {/* 신청내역 설명 */}
                <div className="relative inline-block request-description">
                    <button
                        onClick={() => setShowTooltip(!showTooltip)}
                        className="text-blue-500 hover:underline flex items-center"
                    >
                        <FaQuestionCircle className="mr-1" />
                    </button>
                    {showTooltip && (
                        <div className="absolute z-10 w-72 p-3 bg-white border rounded-lg shadow-lg text-sm text-gray-700">
                            <p><strong>7단계의 현황으로 알려드립니다.</strong></p>
                            <p><span className="font-semibold text-gray-400">접수 대기</span> - 신청서 제출완료, 상담 진행 단계</p>
                            <p><span className="font-semibold text-black">접수 완료</span> - 상담완료, 제작 진행 전 단계</p>
                            <p><span className="font-semibold text-blue-500">제작 진행중</span> - 제작 진행중, 제작 완료 전 단계</p>
                            <p><span className="font-semibold text-gray-500">상품 제작 완료</span> - 제작 완료, 제작물 전달 전</p>
                            <p><span className="font-semibold text-gray-500">상품 전달 완료</span> - 제작 완료, 제작물 전달 전</p>
                            <p><span className="font-semibold text-red-500">거절</span> - 신청서 거절, 상담 진행 단계</p>
                            <p><span className="font-semibold text-orange-500">신청 취소</span> - 신청서 제출 후 취소</p>
                        </div>
                    )}
                </div>

                {/* 신청내역 리스트 */}
                {orders.length > 0 ? (
                    orders.map((order) => (
                        <div key={order.applicationId} className="flex justify-between items-center bg-gray-100 p-4 rounded-lg shadow-md mb-6" role={"button"} onClick={handleOrderClick ? () => handleOrderClick(order) : null}>
                            <div>
                                <h3 className="text-lg font-semibold">{order.title}</h3>
                                <p className="text-gray-500">작성일 {order.updateDate == null ? order.submitDate : order.updateDate}</p>
                                <p className="text-gray-500">신청번호 {order.applicationNumber}</p>
                            </div>
                            <button
                                className={`custom-order-history-buttons border px-4 py-1 rounded-md ${statusStyles[statusChange[order.articleStatus]] || "border-gray-300 text-gray-500"}`}
                            >
                                {statusChange[order.articleStatus]}
                            </button>
                        </div>
                    ))
                ) : (
                    <p className="text-gray-500">신청 내역이 없습니다.</p>
                )}
            </div>
        </div>
    );
};

export default CustomOrderHistory;
